import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from './FormControl.js';
import { BaseMaskedFormControl } from './MaskedInput.js';
var _excluded = ["setError", "dataValue", "placeholderChar", "onDataLoaded"];

var MaskedFormControl = /*#__PURE__*/function (_FormControl) {
  function MaskedFormControl(props) {
    var _this;

    _classCallCheck(this, MaskedFormControl);

    _this = _callSuper(this, MaskedFormControl, [props]);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  _inherits(MaskedFormControl, _FormControl);

  return _createClass(MaskedFormControl, [{
    key: "onBlur",
    value: function onBlur(e) {
      if (typeof this.props.onValueChange === 'function') {
        this.props.onValueChange(_defineProperty({}, this.props.name, e.currentTarget.value));
      }

      this.checkError();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props;
      _this$props.setError;
      _this$props.dataValue;
      _this$props.placeholderChar;
      _this$props.onDataLoaded;

      var props = _objectWithoutProperties(_this$props, _excluded); // eslint-disable-line no-unused-vars


      return /*#__PURE__*/React.createElement(BaseMaskedFormControl, _extends({}, props, {
        onBlur: this.onBlur,
        ref: function ref(input) {
          return _this2.input = input;
        },
        value: this.state.value,
        onChange: this.onFormChange
      }), this.props.children);
    }
  }]);
}(FormControl);

_defineProperty(MaskedFormControl, "propTypes", {
  children: PropTypes.any,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  dataValue: PropTypes.any
});

MaskedFormControl.displayName = "MaskedFormControl";
export { MaskedFormControl };